module.exports = __webpack_public_path__ + "static/img/m_hover_com.7242fd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/m_hover_com.png
// module id = WzRd
// module chunks = 1